export default "__VITE_ASSET__Ozqw43XZ__"